import styles from './Profile.module.scss';
import { Avatar, Dropdown, Menu, Typography } from 'antd';
import { LockOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeUpdatePasswordModalVisibility } from '../../../../redux/actions/global';
import { logoutUser } from '../../../../redux/actions/auth';
import ROUTES from '../../../../utils/routes';

const { Text } = Typography;

const Profile = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);

    const onChangePasswordClick = () => {
        dispatch(changeUpdatePasswordModalVisibility(true));
    };

    const onLogout = () => {
        dispatch(logoutUser());
    };

    const menuOverlay = (
        <Menu>
            <Menu.Item>
                <Link to={'#'} onClick={onChangePasswordClick}>
                    <LockOutlined /> <Text>Change Password</Text>
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to={ROUTES.LOGIN.path} onClick={onLogout}>
                    <LogoutOutlined /> Sign out
                </Link>
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menuOverlay} placement='bottomCenter'>
            <div className={styles.profile}>
                <Avatar icon={<UserOutlined />} />
                {user.firstName} {user.lastName}
            </div>
        </Dropdown>
    );
};

export default Profile;
